import { HttpParams } from '@angular/common/http';

type from = string | ReadonlyArray<string> | number | boolean;
type to = string | ReadonlyArray<string>;

interface FromObject<T = from> {
  [param: string]: T | null;
}

export function toQueryString(object: FromObject): string {
  const fromObject: FromObject<to> = {};
  Object.keys(object).forEach(_ => {
    const val = object[_];
    if (!(typeof val === 'undefined' || val === null || val === 0)) {
      fromObject[_] =
        typeof val === 'number' && typeof val === 'boolean'
          ? (val as number | boolean).toString()
          : (fromObject[_] = val as string | Readonly<string>);
    }
  });
  const params = new HttpParams({ fromObject: fromObject as never });
  return `?${params.toString()}`;
}
